var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9834 11.4645C27.1612 12.3281 26.0291 12.9024 24.7466 13.0011C21.9933 13.2129 19.5896 11.1527 19.3777 8.39943C19.3226 7.68276 19.4214 6.98978 19.6463 6.35297C17.5414 7.3612 16.1653 9.58708 16.3551 12.0539C16.6019 15.2606 19.4015 17.6602 22.6083 17.4134C25.7132 17.1745 28.0614 14.5423 27.9834 11.4645Z",
    fill: "url(#paint0_linear_10214_687)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.6125H10.186C7.60386 22.6125 6.11768 20.9603 6.11768 18.9178C6.11768 17.1493 7.23854 15.7545 8.89909 15.2812C9.18969 11.9684 11.913 9.4693 15.1344 9.4693C17.6004 9.4693 19.6262 10.806 20.7305 12.998C23.7444 12.998 25.9612 15.057 25.9612 17.7886C25.9612 20.4953 23.7942 22.6125 20.9962 22.6125Z",
    fill: "#8E8E8E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1723 13.2792L20.3455 13.623H20.7305C23.4495 13.623 25.3362 15.4504 25.3362 17.7886C25.3362 20.1343 23.4651 21.9875 20.9962 21.9875H10.186C9.03131 21.9875 8.17783 21.6207 7.61699 21.0808C7.05544 20.5403 6.74268 19.7841 6.74268 18.9178C6.74268 17.4421 7.6651 16.2828 9.07039 15.8823L9.48411 15.7644L9.5217 15.3358C9.7846 12.3387 12.2441 10.0943 15.1344 10.0943C17.3488 10.0943 19.1671 11.2838 20.1723 13.2792Z",
    stroke: "#8E8E8E",
    strokeOpacity: 0.4,
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_687",
    x: -13.8823,
    y: -10.5307,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_687",
    x1: 19.6975,
    y1: 8.77626,
    x2: 28.536,
    y2: 11.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02N);
export default __webpack_public_path__ + "static/media/02n.4d4221abb0ae17fce5f86e477399fe5d.svg";
export { ForwardRef as ReactComponent };